<template>
  <div class="tab-content" id="PTtab-5" :key="'PTtab-5'">
      <div class="pagenamPT">
        <h3 class="pagename2">{{ $t('front.common.memberList') }}</h3>
      </div>
      <div class="partnerTop">
        <div class="select">
          <a @click="userListOrder = 'JOIN_DESC'">{{ $t('front.common.latest') }}</a>
          <a @click="userListOrder = 'ID_ASC'">{{ $t('front.common.byID') }}</a>
          <button type="button" :class="{ on: userListOrder.startsWith('CASH_') }" @click="toggleCashOrder">
            {{ $t('front.common.byMoney') }} {{ userListOrder === 'CASH_ASC' ? '↑ 오름차순' : '↓ 내림차순' }}
          </button>
          <button type="button" :class="{ on: userListOrder.startsWith('LAST_LOGIN_') }" @click="toggleLoginOrder">
            최근 로그인순 {{ userListOrder === 'LAST_LOGIN_ASC' ? '↑ 오래된 순' : '↓ 최근 순' }}
          </button>
          <a @click="userListOrder = 'POINT_DESC'">{{ $t('front.common.byRolling') }}</a>
        </div>
        <div class="fx-center-end">
          <select class="selectBox" v-model="searchType">
            <option :value="'id'">{{ $t('front.common.memId') }}</option>
            <option :value="'nickname'">{{ $t('front.common.nickName') }}</option>
          </select>
          <input type="text" class="input" v-model="searchValue"/>
          <date-filter-Pt @search="goToPage(1)" :startDate="startDate" :endDate="endDate" @update="onUpdateDate" />
        </div>
      </div>
      <p v-if="userListError" role="alert">{{ userListError }}</p>
      <!-- 모바일용 전체 파트너 목록 버튼 -->
      <div class="userTreeMobileBtn" @click="userTreeOpen = !userTreeOpen">
        전체 파트너 목록 보기
      </div>
      <div class="userTreeDropdown" v-show="userTreeOpen">
        <PartnerHierarchy
          @onClickMemId="onClickUserTree"
          :treeOption="treeOption"
          @onUpdateTreeOption="onUpdateTreeOption"
        />
      </div>
      <div class="strTableWrap">
        <!-- PC용 트리 -->
        <div class="userTreePc">
          <PartnerHierarchy
            @onClickMemId="onClickUserTree"
            :treeOption="treeOption"
            @onUpdateTreeOption="onUpdateTreeOption"
          />
        </div>
        <div class="strTablescr">
          <div class="strTablePC">
            <table class="strTablePT">
              <colgroup>
                <col style="width:8%;">
                <col style="width:8%;">
                <col style="width:10%;">
                <col style="width:5%;">
                <col style="width:10%;">
                <col style="width:10%;">
                <col style="width:15%;">
                <col style="width:15%;">
                <col style="width:5%;">
              </colgroup>
              <thead>
                <tr>
                  <th>{{ $t('front.common.memId') }}<br />{{ $t('front.common.nickName') }}</th>
                  <th>{{ $t('front.common.department') }}</th>
                  <th>{{ $t('front.cash.nav3') }}<br />{{ $t('front.cash.nav4') }}</th>
                  <th>{{ $t('front.common.inTotal') }} / {{ $t('front.cash.exchange') }}</th>
                  <th>{{ $t('front.stributor.roll') }} % ({{ $t('front.gnb.casino') }})<br />{{ $t('front.stributor.roll') }} % ({{ $t('front.gnb.slot') }})</th>
                  <th>{{ $t('front.common.deposit') }} / {{ $t('front.common.withdrawal') }}<br />{{ $t('front.stributor.m5') }} / {{ $t('front.stributor.m6') }}</th>
                  <th><span class="fs12">{{ $t('front.bettingStatus.BET') }} / {{ $t('front.common.winning') }} / {{ $t('front.stributor.roll') }} / {{ $t('front.common.acquiRoll') }}</span><br />({{ $t('front.gnb.casino') }})</th>
                  <th><span class="fs12">{{ $t('front.bettingStatus.BET') }} / {{ $t('front.common.winning') }} / {{ $t('front.stributor.roll') }} / {{ $t('front.common.acquiRoll') }}</span><br />({{ $t('front.gnb.slot') }})</th>
                  <th>{{ $t('front.common.details') }}</th>
                </tr>
              </thead>
              <tbody>
                <template v-if="userList && userList.length > 0">
                  <tr v-for="(user, index) in userList" :key="user.memId">
                    <td>
                      {{user.memId}}<br />
                      <span class="nick">{{user.memNick}}</span><br/>
                      <span>({{ user.memName }})</span>
                    </td>
                    <td>
                      <div class="topwrap" v-if="user.topUserList && user.topUserList.length > 0 && user.topUserList !== '0'">
                        <select class="h20 upperUser">
                          <option v-for="pt in user.topUserList.slice(0, 1)" :key="pt.recommenderId">
                            <span>[{{pt.partnerLevelName}}] </span>
                            <span>{{pt.recommenderId}}</span>
                          </option>
                        </select>
                        <i class="icon">+</i>
                      </div>
                      <div v-else>
                        -
                      </div>
                    </td>
                    <td>
                      <div class="twoline-wrap">
                        <span>{{thousand(user.cashAmt || 0)}}</span>
                        <span>{{thousand(user.pointAmt || 0)}}</span>
                      </div>
                    </td>
                    <td>
                      <div class="btn-input-wrap">
                        <a class="inout-btn btn-green" @click="onOpenPay(user, index)">{{ $t('front.give.give') }}/{{ $t('front.give.back') }}</a>
                      </div>
                    </td>
                    <td>
                      <div class="btn-input-wrap">
                        <span class="rate-font roboto">{{user.casinoRate}}%/{{user.slotRate}}%</span>
                        <a class="plus-btn" @click="onOpenRate(user, index)"></a>
                      </div>
                    </td>
                    <td>
                      <div class="twoline-wrap">
                        <span>{{thousand(user.cashIn || 0)}}</span>
                        <span class="plusAmt minusAmt">{{thousand(user.cashOut || 0)}}</span>
                        <span>{{thousand(user.payment || 0)}}</span>
                        <span>{{thousand(user.payback || 0)}}</span>
                      </div>
                    </td>
                    <td>
                      <div class="twoline-wrap">
                        <span>{{thousand(user.casinoBetAmt || 0)}}</span>
                        <span>{{thousand(user.casinoWinAmt || 0)}}</span>
                        <span>{{thousand(user.casinoRolling || 0)}}</span>
                        <span>{{thousand(user.byCasino || 0)}}</span>
                      </div>
                    </td>
                    <td>
                      <div class="twoline-wrap">
                        <span>{{thousand(user.slotBetAmt || 0)}}</span>
                        <span>{{thousand(user.slotWinAmt || 0)}}</span>
                        <span>{{thousand(user.slotRolling || 0)}}</span>
                        <span>{{thousand(user.bySlot || 0)}}</span>
                      </div>
                    </td>
                    <td>
                      <div class="btn-input-wrap actionBtnWrap">
                        <a class="inout-btn btn-orange" @click="goToDetail(user.memId)">
                          {{ $t('front.stributor.detailList') }}
                        </a>
                        <a class="inout-btn btn-purple" @click="goToBetDetail(user.memId)">
                          베팅내역
                        </a>
                      </div>
                    </td>
                  </tr>
                </template>
                <template v-else-if="userList && !userListError">
                  <tr>
                    <td colspan="10">회원이 없습니다.</td>
                  </tr>
                </template>

              </tbody>
            </table>
          </div>
          <div class="userCardM">
            <template v-if="userList && userList.length > 0">
              <div class="userCard" v-for="(user, index) in userList" :key="user.memId">
                <div class="userCardHead">
                  <div>
                    <strong>{{ user.memId }}</strong>
                    <span>{{ user.memNick }}</span>
                    <small>({{ user.memName }})</small>
                  </div>
                </div>

                <div class="userCardBody">
                  <div class="row">
                    <em>소속</em>
                    <div class="topwrap" v-if="user.topUserList && user.topUserList.length > 0 && user.topUserList !== '0'">
                      <select class="h20 upperUser mw-auto">
                        <option v-for="pt in user.topUserList.slice(0, 1)" :key="pt.recommenderId">
                          [{{pt.partnerLevelName}}] {{pt.recommenderId}}
                        </option>
                      </select>
                      <i class="icon">+</i>
                    </div>
                    <span v-else>-</span>
                  </div>

                  <div class="row">
                    <em>보유머니</em>
                    <span>{{ thousand(user.cashAmt || 0) }}</span>
                  </div>

                  <div class="row">
                    <em>보유포인트</em>
                    <span>{{ thousand(user.pointAmt || 0) }}</span>
                  </div>

                  <div class="row">
                    <em>충전 / 환전</em>
                    <div class="btns">
                      <a class="inout-btn btn-green" @click="onOpenPay(user, index)">
                        지급/회수
                      </a>
                    </div>
                  </div>

                  <div class="row">
                    <em>롤링</em>
                    <span>{{ user.casinoRate }}% / {{ user.slotRate }}%</span>
                    <a class="plus-btn" @click="onOpenRate(user, index)"></a>
                  </div>

                  <div class="row">
                    <em>총 입금</em>
                    <span>{{ thousand(user.cashIn || 0) }}</span>
                  </div>

                  <div class="row">
                    <em>총 출금</em>
                    <span class="plusAmt minusAmt">{{ thousand(user.cashOut || 0) }}</span>
                  </div>

                  <div class="row">
                    <em>머니지급</em>
                    <span>{{ thousand(user.payment || 0) }}</span>
                  </div>

                  <div class="row">
                    <em>머니회수</em>
                    <span>{{ thousand(user.payback || 0) }}</span>
                  </div>

                  <div class="summaryBox">
                    <h5>카지노</h5>
                    <div>
                      <span>베팅</span>
                      <strong>{{ thousand(user.casinoBetAmt || 0) }}</strong>
                    </div>
                    <div>
                      <span>당첨</span>
                      <strong>{{ thousand(user.casinoWinAmt || 0) }}</strong>
                    </div>
                    <div>
                      <span>롤링</span>
                      <strong>{{ thousand(user.casinoRolling || 0) }}</strong>
                    </div>
                    <div>
                      <span>획득롤링</span>
                      <strong>{{ thousand(user.byCasino || 0) }}</strong>
                    </div>
                  </div>

                  <div class="summaryBox">
                    <h5>슬롯</h5>
                    <div>
                      <span>베팅</span>
                      <strong>{{ thousand(user.slotBetAmt || 0) }}</strong>
                    </div>
                    <div>
                      <span>당첨</span>
                      <strong>{{ thousand(user.slotWinAmt || 0) }}</strong>
                    </div>
                    <div>
                      <span>롤링</span>
                      <strong>{{ thousand(user.slotRolling || 0) }}</strong>
                    </div>
                    <div>
                      <span>획득롤링</span>
                      <strong>{{ thousand(user.bySlot || 0) }}</strong>
                    </div>
                  </div>
                </div>

                <div class="userCardBtnWrap">
                  <a class="userCardBtn" @click="goToDetail(user.memId)">
                    상세보기
                  </a>
                  <a class="userCardBtn bet" @click="goToBetDetail(user.memId)">
                    베팅내역
                  </a>
                </div>
              </div>
            </template>

            <div class="userCardEmpty" v-else-if="userList && !userListError">
              회원이 없습니다.
            </div>
          </div>
        </div>
      </div>
    <pagination v-if="pageInfo && userList && !userListError"
                :pageNum="pageInfo.page"
                :pageSize="pageInfo.count_per_list"
                :totalCount="pageInfo.tatal_list_count"
                @goToPage="goToPage"
    >
    </pagination>
    <transition name="fade">
      <RateTable v-if="RateOpen" :selectMem="selectMem" :selectIdx="selectIdx"  @close="onCloseRate"/>
    </transition>
    <transition name="fade">
      <Paymodal v-if="PayMopen" :selectMem="selectMem" :selectIdx="selectIdx" @close="onClosePay" />
    </transition>
  </div>
</template>

<script>
import DateFilterPt from '@/components/ui/DateFilterPt'
import RateTable from '@/components/common/RateTable.vue'
import Paymodal from '@/components/common/Pay.vue'
import Pagination from '@/components/ui/Pagination.vue'
import { mapState } from 'vuex'
import { getPartnerHierarchyV2 } from '@/api/v2/partner'
import { getUserListV2 } from '@/api/v2/user'
import { getDateStr, thousand } from '@/libs/utils'
import { addDays } from 'date-fns'
import PartnerHierarchy from '@/components/common/mobile/PartnerHierarchy.vue'
export default {
  name: 'partnerUserList',
  components: { PartnerHierarchy, DateFilterPt, Pagination, RateTable, Paymodal },
  computed: {
    ...mapState([
      'userData',
      'gameCount',
      'commonCodeByOrder',
      'commonCodeByCode'
    ])
  },
  data () {
    return {
      userTreeOpen: false,
      searchType: 'id',
      searchValue: '',
      RateOpen: false,
      PayMopen: false,
      partnerList: null,
      selectIdx: null,
      selectMem: null,
      selectedLi: null,
      userList: null,
      userListError: '',
      userListOrder: 'ID_ASC',
      startDate: getDateStr(addDays(new Date(), 0), 'yyyy-MM-dd 00:00:00'),
      endDate: getDateStr(addDays(new Date(), 0), 'yyyy-MM-dd 23:59:59'),
      treeOption: 'N'
    }
  },
  async created () {
    this.emitter.emit('Loading', true)
    await this.getHierarchyList('', 'main', null)
    await this.loadSubList(this.userData.memId, 'main', null, 1)
    this.selectedLi = this.userData.memId
    this.emitter.emit('Loading', false)
  },
  watch: {
    userListOrder () {
      this.loadSubList(this.selectedLi, 'sub', null, 1)
    }
  },
  methods: {
    toggleCashOrder () {
      this.userListOrder = this.userListOrder === 'CASH_DESC' ? 'CASH_ASC' : 'CASH_DESC'
    },
    toggleLoginOrder () {
      this.userListOrder = this.userListOrder === 'LAST_LOGIN_DESC' ? 'LAST_LOGIN_ASC' : 'LAST_LOGIN_DESC'
    },
    goToBetDetail (memId) {
      this.$router.push({
        name: 'userDetail',
        query: {
          id: memId,
          tab: 'userBet'
        }
      })
    },
    onClickUserTree (memId, type, item) {
      this.loadSubList(memId, type, item, 1)

      if (window.innerWidth <= 1000) {
        this.userTreeOpen = false
      }
    },
    thousand,
    onUpdateDate (value) {
      console.log(value)
      this.startDate = value.startDate
      this.endDate = value.endDate
    },
    onUpdateTreeOption (value) {
      this.treeOption = value
    },
    onCloseRate () {
      this.RateOpen = false
      this.selectMem = null
      this.selectIdx = null
    },
    onClosePay (newCash, idx) {
      if (newCash !== null && newCash !== undefined) {
        this.userList[idx].cashAmt = newCash
      }
      this.PayMopen = false
      this.selectMem = null
      this.selectIdx = null
    },
    onOpenPay (selectMem, selectIdx) {
      this.selectMem = {
        ...selectMem,
        cashAmt: thousand(selectMem.cashAmt)
      }
      this.selectIdx = selectIdx
      this.PayMopen = true
    },
    onOpenRate (selectMem, selectIdx) {
      this.selectMem = {
        ...selectMem,
        cashAmt: thousand(selectMem.cashAmt)
      }
      this.selectIdx = selectIdx
      this.RateOpen = true
    },
    goToDetail (memId) {
      this.detailOpen('user', memId)
    },
    goToPage (page) {
      this.loadSubList(this.selectedLi, 'sub', null, page)
    },
    async loadSubList (memId, type, item, page) {
      if (memId) {
        this.selectedLi = memId
      }
      this.userList = null
      this.userListError = ''
      if (!page) {
        page = this.pageInfo.page
      } else {
        this.pageInfo.page = page
      }
      this.emitter.emit('Loading', true)

      const params = {
        memId: memId,
        targetLevel: '',
        searchType: this.searchType,
        searchValue: this.searchValue,
        startDate: this.startDate,
        endDate: this.endDate,
        orderStr: this.userListOrder,
        page: page,
        count_per_list: 50,
        treeOption: this.treeOption
      }

      try {
        const res = await getUserListV2(params)
        const result = res.data
        if (result.resultCode !== '0' || !Array.isArray(result.data?.list)) {
          throw new Error('Member list request failed')
        }
        this.userList = result.data.list

        if (result.data.pageInfo) {
          this.pageInfo = result.data.pageInfo
        } else {
          this.pageInfo.page = 1
          this.pageInfo.tatal_list_count = 0
        }
      } catch (error) {
        this.userListError = '회원목록 조회에 실패했습니다. 정렬 조건을 바꾸거나 잠시 후 다시 검색해 주세요.'
      } finally {
        this.emitter.emit('Loading', false)
      }
    },
    getHierarchyList (memId, type, item) {
      this.emitter.emit('Loading', true)
      const params = {
        memId: memId
      }
      return getPartnerHierarchyV2(params).then(res => {
        const result = res.data
        console.log('getPartnerHierarchyV2 : ', params, result)
        const list = result.data.hierarchy
        if (type === 'sub') {
          item.children = list
          item.open = !item.open
          if (this.selectedLi === memId) {
            this.selectedLi = memId
          } else {
            this.selectedLi = memId
          }

          // this.loadSubList(memId, 1, type)
        } else {
          this.partnerList = list
        }

        this.emitter.emit('Loading', false)

        return true
      })
    }
  }
}
</script>

<style src="@/styles/striNew.css"></style>
<style scoped>
.fs12 {font-size: 12px;}
.tab-content {
  min-height: calc(100vh - 54px);
  background: #f3f6fb;
  color: #172033;
  box-sizing: border-box;
}
.pagenamPT {
  margin: 0 0 18px;
}
.pagename2 {
  position: relative;
  margin: 0;
  padding-left: 18px;
  color: #172033;
  font-size: 20px;
  font-weight: 800;
  letter-spacing: -0.5px;
}
.pagename2::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  width: 6px;
  height: 20px;
  border-radius: 6px;
  background: #2f80ed;
  transform: translateY(-50%);
}

/* 검색/정렬 영역 */
.partnerTop {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 18px;
  min-height: 76px;
  margin-bottom: 18px;
  padding: 18px;
  border: 1px solid #dfe7f2;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 6px 18px rgba(27, 39, 64, 0.06);
  box-sizing: border-box;
}

.select {
  display: flex;
  align-items: center;
  gap: 7px;
  flex-wrap: wrap;
}

.select a, .select button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 86px;
  height: 34px;
  padding: 0 15px;
  border: 1px solid #cfd9e7;
  border-radius: 7px;
  background: #f8fafc;
  color: #526071;
  font-size: 13px;
  font-weight: 700;
  line-height: 1;
  cursor: pointer;
  box-sizing: border-box;
  transition: all .15s ease;
}

.select a.on,
.select a:hover,
.select button.on,
.select button:hover {
  border-color: #2f80ed;
  background: #2f80ed;
  color: #fff;
  box-shadow: 0 4px 10px rgba(47, 128, 237, 0.22);
}

.fx-center-end {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  flex-wrap: wrap;
}

.selectBox,
.input {
  height: 38px !important;
  margin: 0 !important;
  border: 1px solid #cfd9e7 !important;
  border-radius: 7px !important;
  background-color: #fff !important;
  color: #172033 !important;
  font-size: 14px !important;
  box-sizing: border-box !important;
  outline: none;
}

.selectBox {
  min-width: 112px;
  padding: 0 30px 0 12px !important;
}

.input {
  width: 300px;
  padding: 0 12px !important;
}

.input:focus,
.selectBox:focus {
  border-color: #2f80ed !important;
  box-shadow: 0 0 0 3px rgba(47, 128, 237, 0.12);
}

/* 날짜검색 컴포넌트 보정 */
.fx-center-end .datesearchPT,
.fx-center-end .datesearchPTWarp,
.fx-center-end .datesearch {
  margin: 0 !important;
}

.fx-center-end input[type='date'],
.fx-center-end input[type='text'] {
  border-color: #cfd9e7;
}

.fx-center-end .dateBtn,
.fx-center-end .bga,
.fx-center-end button {
  min-width: 54px;
  height: 38px !important;
  margin: 0 !important;
  padding: 0 14px !important;
  border: 0 !important;
  border-radius: 7px !important;
  background: #2f80ed !important;
  color: #fff !important;
  font-size: 13px !important;
  font-weight: 800 !important;
  cursor: pointer;
  box-shadow: 0 4px 10px rgba(47, 128, 237, 0.22);
}

/* 본문 레이아웃 */
.strTableWrap {
  display: flex;
  align-items: flex-start;
  gap: 18px;
  width: 100%;
  min-height: auto;
}

.userTreePc {
  display: block;
  width: 282px;
  min-width: 282px;
  flex-shrink: 0;
}

.userTreePc .subMemWrap,
.userTreeDropdown .subMemWrap {
  width: 100%;
  border: 1px solid #dfe7f2 !important;
  border-radius: 10px !important;
  background: #fff !important;
  box-shadow: 0 6px 18px rgba(27, 39, 64, 0.06) !important;
  overflow: hidden;
}

.strTablescr {
  flex: 1;
  min-width: 0;
  border: 1px solid #dfe7f2;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 6px 18px rgba(27, 39, 64, 0.06);
  overflow: hidden;
}

.strTablePC {
  width: 100%;
  overflow-x: auto;
}

.strTablePT {
  width: 100%;
  min-width: 1160px;
  border-collapse: separate;
  border-spacing: 0;
  background: #fff;
}

.strTablePT thead th {
  height: 48px;
  padding: 10px 8px;
  border: 0;
  border-bottom: 1px solid #d8e1ee;
  background: #edf3fb;
  color: #172033;
  font-size: 13px;
  font-weight: 800;
  line-height: 1.35;
  text-align: center;
  white-space: nowrap;
}

.strTablePT tbody td {
  min-height: 70px;
  padding: 14px 8px;
  border: 0;
  border-bottom: 1px solid #e3e9f2;
  background: #fff;
  color: #203047;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.45;
  text-align: center;
  vertical-align: middle;
}

.strTablePT tbody tr:nth-child(even) td {
  background: #f7f9fc;
}

.strTablePT tbody tr:hover td {
  background: #f1f6ff;
}

.strTablePT tbody tr:last-child td {
  border-bottom: 0;
}

.nick {
  color: #ff7e00;
  font-weight: 800;
}

.roboto,
.rate-font {
  font-family: 'Roboto', 'Noto Sans KR', sans-serif;
}

.twoline-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

.plusAmt,
.minusAmt {
  color: #ff3b30;
}

.btn-input-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.actionBtnWrap {
  flex-direction: column;
  gap: 6px;
}

.inout-btn,
.btnp {
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 60px;
  height: 28px;
  padding: 0 10px;
  border-radius: 6px;
  color: #fff !important;
  font-size: 12px;
  font-weight: 800;
  line-height: 1.1;
  text-align: center;
  cursor: pointer;
  box-shadow: 0 3px 8px rgba(27, 39, 64, 0.14);
  box-sizing: border-box;
}

.btn-green {
  background: #129760 !important;
}

.btn-orange {
  background: #e28a00 !important;
}

.btn-purple {
  background: #5b63ce !important;
}

.topwrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  max-width: 100%;
}

.upperUser {
  height: 24px !important;
  min-width: 132px;
  padding: 0 24px 0 7px !important;
  border: 1px solid #cfd9e7 !important;
  border-radius: 5px !important;
  background: #fff !important;
  color: #536175 !important;
  font-size: 12px !important;
}

.topwrap .icon,
.plus-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 4px;
  background: #6a7480;
  color: #fff;
  font-size: 12px;
  font-weight: 900;
  line-height: 16px;
  cursor: pointer;
}

.plus-btn::before {
  content: '+';
}

.flex-c {flex-direction: column;}
.gap-2 {gap: 2px;}

/* 모바일 트리 버튼 기본 숨김 */
.userTreeMobileBtn,
.userTreeDropdown,
.userCardM {
  display: none;
}

.subPT_1 li {position: relative;}

.allBtn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 57px;
  height: 20px;
  border: 1px solid #000;
  border-radius: 2px;
  background: #e50000;
  color: #fff;
  font-size: 11px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.16);
  box-sizing: border-box;
}

/* ================= 모바일 ================= */
@media (max-width: 1000px) {
  .tab-content {
    padding: 14px 12px 28px;
  }

  .pagename2 {
    font-size: 18px;
  }

  .strTablePC,
  .userTreePc {
    display: none;
  }

  .partnerTop {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
    padding: 14px;
    border-radius: 12px;
  }

  .select {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    width: 100%;
    gap: 7px;
  }

  .select a, .select button {
    width: 100%;
    height: 38px;
    min-width: 0;
    padding: 0 5px;
    border-radius: 9px;
    font-size: 12px;
  }

  .fx-center-end {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    gap: 8px;
    justify-content: stretch;
  }

  .fx-center-end .selectBox {
    width: 96px;
    flex: 0 0 96px;
    min-width: 96px;
    height: 38px !important;
  }

  .fx-center-end .input {
    width: calc(100% - 104px);
    flex: 1;
    min-width: 0 !important;
    height: 38px !important;
  }

  .fx-center-end .datesearchPT,
  .fx-center-end .datesearchPTWarp,
  .fx-center-end .datesearch {
    width: 100%;
    display: flex;
    gap: 6px;
    justify-content: space-between;
  }

  .fx-center-end input[type='date'] {
    width: calc(50% - 30px);
    min-width: 0 !important;
    height: 38px !important;
    padding: 0 6px !important;
    font-size: 12px !important;
  }

  .fx-center-end .dateBtn,
  .fx-center-end .bga {
    width: 50px !important;
    min-width: 50px !important;
    height: 38px !important;
    padding: 0 !important;
  }

  .userTreeMobileBtn {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 44px;
    padding: 0 15px;
    margin-bottom: 8px;
    border-radius: 10px;
    background: #2f80ed;
    color: #fff;
    font-size: 14px;
    font-weight: 800;
    cursor: pointer;
    box-shadow: 0 6px 14px rgba(47, 128, 237, 0.18);
  }

  .userTreeMobileBtn::after {
    content: '›';
    font-size: 22px;
  }

  .userTreeDropdown {
    display: block;
    width: 100%;
    max-height: 420px;
    margin-bottom: 14px;
    border: 1px solid #dfe7f2;
    border-radius: 0 0 12px 12px;
    background: #fff;
    overflow-y: auto;
    box-shadow: 0 6px 18px rgba(27, 39, 64, 0.08);
  }

  .strTableWrap {
    flex-direction: column;
    gap: 12px;
  }

  .strTablescr {
    width: 100%;
    border: 0;
    border-radius: 0;
    background: transparent;
    box-shadow: none;
    overflow: visible;
  }

  .userCardM {
    display: flex;
    flex-direction: column;
    gap: 14px;
    width: 100%;
  }

  .userCard {
    border: 1px solid #dfe7f2;
    border-radius: 14px;
    background: #fff;
    overflow: hidden;
    box-shadow: 0 6px 18px rgba(27, 39, 64, 0.08);
  }

  .userCardHead {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    padding: 15px;
    border-bottom: 1px solid #e5ecf5;
    background: linear-gradient(135deg, #f8fbff, #edf4ff);
  }

  .userCardHead strong {
    display: block;
    color: #172033;
    font-size: 16px;
    font-weight: 900;
    line-height: 1.2;
  }

  .userCardHead span {
    display: block;
    margin-top: 4px;
    color: #ff7e00;
    font-size: 13px;
    font-weight: 800;
  }

  .userCardHead small {
    display: block;
    margin-top: 3px;
    color: #7b8798;
    font-size: 12px;
  }

  .userCardBody {
    padding: 6px 14px 4px;
  }

  .userCardBody .row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    min-height: 42px;
    padding: 7px 0;
    border-bottom: 1px solid #eef2f7;
    color: #172033;
    font-size: 13px;
  }

  .userCardBody .row em {
    flex: 0 0 105px;
    color: #6b7788;
    font-size: 12px;
    font-weight: 800;
    line-height: 1.3;
  }

  .userCardBody .row span,
  .userCardBody .row > div {
    flex: 1;
    text-align: right;
    justify-content: flex-end;
    word-break: break-all;
    color: #172033;
    font-weight: 700;
  }

  .userCardBody .row .plus-btn {
    flex: 0 0 16px;
  }

  .userCardBody .topwrap {
    width: 100%;
    max-width: 190px;
    height: 28px;
    margin-left: auto;
  }

  .userCardBody .topwrap select.upperUser {
    height: 28px !important;
    font-size: 11px !important;
  }

  .userCardBody .btns {
    display: flex;
    justify-content: flex-end;
    gap: 6px;
  }

  .userCardBody .inout-btn {
    width: auto;
    min-width: 66px;
    height: 30px;
    padding: 0 8px;
    border-radius: 8px;
    font-size: 11px;
    box-shadow: none;
  }

  .summaryBox {
    margin: 10px 0;
    padding: 11px;
    border: 1px solid #e4ebf5;
    border-radius: 12px;
    background: #f8fafc;
  }

  .summaryBox h5 {
    margin: 0 0 8px;
    color: #2f80ed;
    font-size: 13px;
    font-weight: 900;
  }

  .summaryBox div {
    display: flex;
    justify-content: space-between;
    padding: 5px 0;
    font-size: 12px;
  }

  .summaryBox span {
    color: #7b8798;
  }

  .summaryBox strong {
    color: #172033;
    font-weight: 800;
  }

  .userCardBtnWrap {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
    margin: 8px 14px 14px;
  }

  .userCardBtn {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 42px;
    margin: 0;
    border-radius: 10px;
    background: #2f80ed;
    color: #fff;
    font-size: 14px;
    font-weight: 800;
    cursor: pointer;
  }

  .userCardBtn.bet {
    background: #5b63ce;
  }

  .userCardBtn:active {
    transform: scale(0.98);
  }

  .userCardEmpty {
    padding: 35px 12px;
    border: 1px solid #dfe7f2;
    border-radius: 14px;
    background: #fff;
    color: #7b8798;
    text-align: center;
    font-size: 14px;
    box-shadow: 0 6px 18px rgba(27, 39, 64, 0.08);
  }

  .actionBtnWrap .inout-btn {
    width: 100%;
    height: 32px;
    font-size: 12px;
  }
}

@media (max-width: 500px) {
  .fx-center-end input[type='date'] {
    width: calc(50% - 30px);
    font-size: 11px !important;
  }
}
</style>
